/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Reference_Method_AdpInputs */

const en_us2_body_assessment_reference_method_adp = /** @type {(inputs: Body_Assessment_Reference_Method_AdpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Air displacement (Bod Pod)`)
};

const pt_br2_body_assessment_reference_method_adp = /** @type {(inputs: Body_Assessment_Reference_Method_AdpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pletismografia por ar (Bod Pod)`)
};

const es_419_body_assessment_reference_method_adp = /** @type {(inputs: Body_Assessment_Reference_Method_AdpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pletismografía por aire (Bod Pod)`)
};

const pt_pt2_body_assessment_reference_method_adp = /** @type {(inputs: Body_Assessment_Reference_Method_AdpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pletismografia por ar (Bod Pod)`)
};

const fr_fr2_body_assessment_reference_method_adp = /** @type {(inputs: Body_Assessment_Reference_Method_AdpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pléthysmographie (Bod Pod)`)
};

const de_de2_body_assessment_reference_method_adp = /** @type {(inputs: Body_Assessment_Reference_Method_AdpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luftverdrängung (Bod Pod)`)
};

const it_it2_body_assessment_reference_method_adp = /** @type {(inputs: Body_Assessment_Reference_Method_AdpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pletismografia ad aria (Bod Pod)`)
};

/**
* | output |
* | --- |
* | "Air displacement (Bod Pod)" |
*
* @param {Body_Assessment_Reference_Method_AdpInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_reference_method_adp = /** @type {((inputs?: Body_Assessment_Reference_Method_AdpInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Reference_Method_AdpInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_reference_method_adp(inputs)
	if (locale === "es-419") return es_419_body_assessment_reference_method_adp(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_reference_method_adp(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_reference_method_adp(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_reference_method_adp(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_reference_method_adp(inputs)
	return en_us2_body_assessment_reference_method_adp(inputs)
});
export { body_assessment_reference_method_adp as "body-assessment.reference_method.adp" }